
import logo from '../assets/logoo.png';

export default function Footer() {
    return(
  



<footer class="bg-white dark:bg-gray-900">
<div className="relative isolate overflow-hidden bg-gray-900 bg-inspiration-geometry py-6">
  
  

</div>
    <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div class="md:flex pt-12 md:justify-between">
          <div class="mb-6 md:mb-0">
              <a href="#" class="flex items-center ml-12">
                  <img  src={logo} class="h-[100px] me-3" alt="OHS WORKS" />
              </a>
          </div>
          <div class="grid grid-cols-2 gap-2 ml-12 md:ml-none sm:gap-8 sm:grid-cols-4">
             <div>
              <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Contact Info</h2>

                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                     
                      <li class="mb-4">
                          <a href="#" class="text-[yellow] hover:underline">info@ohsworks.rw</a>
                      </li>
                      <li class="mb-4">
                          <a href="#" class=" text-[yellow] hover:underline">+250 793 763 500</a>
                      </li>
                      <li class="mb-4">
                          <a href="#" class=" text-[green] hover:underline">Rwanda, Kigali</a>
                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">About Us</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">

                      <li class="mb-4">
                          <a href="/about" class="hover:underline">About</a>
                      </li>
                      <li class="mb-4">
                          <a href="/contact" class="hover:underline">Contact Us</a>
                      </li>
                      <li class="mb-4">
                          <a href="/about" class="hover:underline">Mission & Vision</a>
                      </li>
                  </ul>
              </div>
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Quick Links</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                      <li class="mb-4">
                          <a href="/" class="hover:underline">Home</a>
                      </li>
                   
                      <li class="mb-4">
                          <a href="/conference" class="hover:underline">Conference 2024</a>
                      </li>
                      <li class="mb-4">
                          <a href="/register" class="hover:underline">Register Now</a>
                      </li>
                  </ul>
              </div>
            
              <div>
                  <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">Services</h2>
                  <ul class="text-gray-500 dark:text-gray-400 font-medium">
                      <li class="mb-4">
                          <a href="/services/consulting" class="hover:underline">OHS Consulting</a>
                      </li>
                      <li class="mb-4">
                          <a href="/services/conferences" class="hover:underline">OHS Conference</a>
                      </li>
                      <li class="mb-4">
                          <a href="/services/supplies" class="hover:underline">OHS Supplies</a>
                      </li>
                      <li class="mb-4">
                          <a href="/services/education" class="hover:underline">OHS Education</a>
                      </li>
                    
                  </ul>
              </div>
           
          </div>
      </div>
      <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
      <div class="sm:flex sm:items-center sm:justify-between">
          <span class="text-sm text-gray-500 ml-12 sm:text-center dark:text-gray-400">© 2024 <a href="#" class="hover:underline">OHS WORKS</a>. All Rights Reserved.
          </span>
          <div class="flex mt-4 justify-center sm:mt-0">
              <a href="#" class="text-gray-500 hover:text-gray-900 dark:hover:text-white">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 8 19">
                        <path fill-rule="evenodd" d="M6.135 3H8V0H6.135a4.147 4.147 0 0 0-4.142 4.142V6H0v3h2v9.938h3V9h2.021l.592-3H5V3.591A.6.6 0 0 1 5.592 3h.543Z" clip-rule="evenodd"/>
                    </svg>
                  <span class="sr-only">Facebook page</span>
              </a>
     
              <a href="#" class="text-gray-500 hover:text-gray-900 dark:hover:text-white ms-5">
                  <svg class="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 17">
                    <path fill-rule="evenodd" d="M20 1.892a8.178 8.178 0 0 1-2.355.635 4.074 4.074 0 0 0 1.8-2.235 8.344 8.344 0 0 1-2.605.98A4.13 4.13 0 0 0 13.85 0a4.068 4.068 0 0 0-4.1 4.038 4 4 0 0 0 .105.919A11.705 11.705 0 0 1 1.4.734a4.006 4.006 0 0 0 1.268 5.392 4.165 4.165 0 0 1-1.859-.5v.05A4.057 4.057 0 0 0 4.1 9.635a4.19 4.19 0 0 1-1.856.07 4.108 4.108 0 0 0 3.831 2.807A8.36 8.36 0 0 1 0 14.184 11.732 11.732 0 0 0 6.291 16 11.502 11.502 0 0 0 17.964 4.5c0-.177 0-.35-.012-.523A8.143 8.143 0 0 0 20 1.892Z" clip-rule="evenodd"/>
                </svg>
                  <span class="sr-only">Twitter page</span>
              </a>
       
          </div>
      </div>
    </div>
</footer>



    )
}